var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _ellipse2, _g2, _g3, _path16, _g4, _path17, _g5, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChooseUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 493,
    viewBox: "0 0 501 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.953 470.685C426.989 478.499 411.905 484.143 395.278 487.809C383.742 490.299 372.026 491.863 360.242 492.488C315.23 495.238 263.471 486.796 213.591 469.913C202.41 466.15 191.326 461.954 180.434 457.323C99.3255 423.17 28.8192 367.407 9.06011 302.769C-27.0364 184.779 50.4578 99.9283 140.193 22.0723C176.579 -9.52349 224.001 -4.98913 273.061 21.6864C285.046 28.2656 296.575 35.6467 307.567 43.7794C350.796 75.5681 393.592 121.828 429.736 173.25C500.676 274.212 541.737 409.471 439.953 470.685Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.595 332.512L202.429 311.46L230.577 353.38C214.133 367.114 186.507 377.101 172.232 374.051C142.936 367.792 83.7344 284.55 75.5202 278.213C47.5557 256.638 38.4654 248.45 73.4576 265.215C106.819 281.198 89.1492 265.215 97.3229 265.215C107.142 265.901 103.888 274.623 100.244 280.873L166.595 332.512Z",
    fill: "url(#paint0_linear_11381_14456)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.745 294.306C370.635 287.28 330.686 274.624 313.142 269.174L294.58 271.201C282.885 274.102 257.8 279.049 246.261 283.731C234.722 288.412 213.781 303.342 194.246 315.792L198.862 331.793C203.002 346.141 213.956 357.523 228.135 362.209C231.784 385.431 234.931 423.184 234.411 434.888L370.17 434.783L376.385 377.32L404.342 380.317L427.956 362.209C398.387 311.025 393.383 303.088 380.745 294.306Z",
    fill: "url(#paint1_linear_11381_14456)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M419.583 426.346C462.598 420.888 434.621 377.26 426.995 362.851C417.771 370.622 406.378 375.363 394.364 376.431L379.547 377.748L385.617 391.761L320.086 407.114L310.893 432.638C317.441 431.522 366.093 433.133 419.583 426.346Z",
    fill: "url(#paint2_linear_11381_14456)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M313.979 154.631C311.862 150.799 305.791 145.436 298.44 154.631H313.979Z",
    fill: "#30235B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4307,
    cy: 16.7094,
    rx: 23.4307,
    ry: 16.7094,
    transform: "matrix(-1 0 0 1 333.882 269.174)",
    fill: "#3427A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M329.65 284.986L326.375 252.35H294.489L290.826 284.986C292.106 288.829 298.15 296.626 309.343 296.626C323.608 296.626 328.735 288.829 329.65 284.986Z",
    fill: "url(#paint3_linear_11381_14456)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11381_14456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 290,
    y: 252,
    width: 40,
    height: 45
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.65 284.986L326.375 252.35H294.489L290.819 285.052C292.099 288.895 298.164 296.627 309.357 296.627C323.622 296.627 328.735 288.829 329.65 284.986Z",
    fill: "url(#paint4_linear_11381_14456)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11381_14456)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M282.996 253.599C311.827 289.299 327.939 260.595 336.261 256.289L330.542 232.155L296.404 228.075L282.996 253.599Z",
    fill: "#263238"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M311.003 265.452C345.39 265.452 351.303 216.055 340.679 193.461C316.773 164.221 286.892 181.277 274.939 193.461C272.061 212.289 268.888 265.452 311.003 265.452Z",
    fill: "url(#paint5_linear_11381_14456)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M274.352 227.662L281.089 222.695L280.047 218.997L272.352 224.075L274.352 227.662Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M344.542 226.222L337.805 221.255L338.847 217.557L346.542 222.635L344.542 226.222Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M338.378 196.429C313.998 212.325 286.972 203.052 276.506 196.429C278.71 203.385 275.588 216.754 273.752 222.569C257.889 201.896 263.075 190.733 267.65 187.735C268.413 177.432 277.772 151.671 309.193 152.892C340.614 154.113 346.711 176.414 345.821 184.682C357.718 200.862 350.64 216.682 344.902 222.569C338.378 209.893 338.526 201.001 338.378 196.429Z",
    fill: "#30235B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M325.821 233.432C330.686 233.432 333.136 229.595 333.758 227.882C334.474 226.449 335.04 222.716 333.345 219.75C331.189 215.98 321.059 214.929 317.51 220.255C313.962 225.582 317.51 233.432 325.821 233.432Z",
    fill: "#E6FCFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.587 233.432C288.722 233.432 286.272 229.595 285.65 227.882C284.934 226.449 284.369 222.716 286.064 219.75C288.219 215.98 298.35 214.929 301.898 220.255C305.446 225.582 301.898 233.432 293.587 233.432Z",
    fill: "#E6FCFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.997 219.08C322.931 212.107 330.097 215.057 334.343 216.805L334.343 216.805C334.816 217 335.252 217.179 335.649 217.329L338.308 217.334C338.808 217.335 339.212 217.743 339.208 218.244L339.188 220.482C339.184 220.977 338.781 221.376 338.286 221.376L336.364 221.376C337.756 233.339 328.94 236.541 321.89 234.384C315.604 232.462 313.922 227.022 313.585 223.61C312.241 220.628 306.346 222.006 306.113 223.544L306.095 223.665C305.818 225.537 304.424 234.97 293.812 234.983C285.12 234.994 282.763 227.223 282.67 223.336L280.42 223.316C279.922 223.311 279.522 222.904 279.526 222.406L279.551 219.668C279.555 219.17 279.962 218.769 280.461 218.774L282.711 218.794C288.373 213.053 300.535 213.591 304.819 218.99C309.545 217.899 313.573 218.595 314.997 219.08ZM325.821 233.432C330.686 233.432 333.136 229.595 333.758 227.882C334.474 226.449 335.04 222.716 333.345 219.75C331.189 215.98 321.059 214.929 317.51 220.255C313.962 225.582 317.51 233.432 325.821 233.432ZM285.648 227.882C286.271 229.595 288.72 233.432 293.585 233.432C301.896 233.432 305.445 225.582 301.896 220.255C298.348 214.929 288.217 215.98 286.062 219.75C284.367 222.716 284.932 226.449 285.648 227.882Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M373.046 430.047C373.046 429.546 372.64 429.14 372.139 429.14H232.858C231.982 429.14 231.271 429.85 231.271 430.727C231.271 433.357 233.403 435.488 236.032 435.488H367.604C370.609 435.488 373.046 433.052 373.046 430.047Z",
    fill: "#B4B4B4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 141.775,
    height: 94.9278,
    rx: 2.65829,
    transform: "matrix(-1 0 0 1 373.046 336.569)",
    fill: "url(#paint6_linear_11381_14456)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0827,
    cy: 10.0903,
    rx: 10.0827,
    ry: 10.0903,
    transform: "matrix(-1 0 0 1 317.654 373.943)",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11381_14456)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 56.0611,
    height: 43.716,
    rx: 3.15104,
    transform: "matrix(-1 0 0 1 282.673 68.3235)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.264 78.4276C246.67 78.4276 245.378 79.7201 245.378 81.3144V101.522L250.429 98.6355L255.481 101.522L260.533 98.6355L265.585 101.522V81.3144C265.585 79.7201 264.293 78.4276 262.699 78.4276H248.264ZM251.873 82.7579C250.677 82.7579 249.708 83.7272 249.708 84.923C249.708 86.1188 250.677 87.0881 251.873 87.0881C253.069 87.0881 254.038 86.1188 254.038 84.923C254.038 83.7272 253.069 82.7579 251.873 82.7579ZM260.832 83.1806C260.269 82.6169 259.355 82.6169 258.791 83.1806L250.131 91.8411C249.567 92.4048 249.567 93.3188 250.131 93.8824C250.694 94.4461 251.608 94.4461 252.172 93.8824L260.832 85.2219C261.396 84.6582 261.396 83.7443 260.832 83.1806ZM259.09 89.975C257.894 89.975 256.925 90.9443 256.925 92.1401C256.925 93.3359 257.894 94.3052 259.09 94.3052C260.286 94.3052 261.255 93.3359 261.255 92.1401C261.255 90.9443 260.286 89.975 259.09 89.975Z",
    fill: "#FFC34E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_d_11381_14456)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.7504,
    height: 40.3546,
    rx: 4.28255,
    transform: "matrix(-1 0 0 1 221.527 164.852)",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.465 173.152C189.629 173.152 188.951 173.798 188.951 174.595V176.039H187.436C185.764 176.039 184.408 177.331 184.408 178.925V193.36C184.408 194.954 185.764 196.246 187.436 196.246H205.61C207.283 196.246 208.639 194.954 208.639 193.36V178.925C208.639 177.331 207.283 176.039 205.61 176.039H204.095V174.595C204.095 173.798 203.417 173.152 202.581 173.152C201.744 173.152 201.066 173.798 201.066 174.595V176.039H191.98V174.595C191.98 173.798 191.302 173.152 190.465 173.152ZM190.465 180.369C189.629 180.369 188.951 181.015 188.951 181.812C188.951 182.609 189.629 183.256 190.465 183.256H202.581C203.417 183.256 204.095 182.609 204.095 181.812C204.095 181.015 203.417 180.369 202.581 180.369H190.465Z",
    fill: "#87B4FF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_d_11381_14456)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.5234,
    height: 60.9229,
    rx: 4.28255,
    transform: "matrix(-1 0 0 1 147.751 64.715)",
    fill: "white"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.614 81.7564C107.003 81.4077 106.254 81.4077 105.644 81.7564L91.7513 89.6952C90.7996 90.239 90.469 91.4514 91.0128 92.4031C91.3787 93.0435 92.0474 93.4027 92.7357 93.4034V107.296C91.6395 107.296 90.751 108.185 90.751 109.281C90.751 110.377 91.6395 111.265 92.7357 111.265H120.521C121.618 111.265 122.506 110.377 122.506 109.281C122.506 108.185 121.618 107.296 120.521 107.296V93.4034C121.21 93.4029 121.879 93.0437 122.245 92.4031C122.789 91.4514 122.458 90.239 121.506 89.6952L107.614 81.7564ZM98.6898 95.3878C97.5936 95.3878 96.7051 96.2764 96.7051 97.3725V103.327C96.7051 104.423 97.5936 105.311 98.6898 105.311C99.7859 105.311 100.674 104.423 100.674 103.327V97.3725C100.674 96.2764 99.7859 95.3878 98.6898 95.3878ZM104.644 97.3725C104.644 96.2764 105.532 95.3878 106.629 95.3878C107.725 95.3878 108.613 96.2764 108.613 97.3725V103.327C108.613 104.423 107.725 105.311 106.629 105.311C105.532 105.311 104.644 104.423 104.644 103.327V97.3725ZM114.567 95.3878C113.471 95.3878 112.583 96.2764 112.583 97.3725V103.327C112.583 104.423 113.471 105.311 114.567 105.311C115.663 105.311 116.552 104.423 116.552 103.327V97.3725C116.552 96.2764 115.663 95.3878 114.567 95.3878Z",
    fill: "#FF7979"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d_11381_14456)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.3581,
    height: 58.7637,
    rx: 4.28255,
    transform: "matrix(-1 0 0 1 117.033 181.993)",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5642 228.904C89.0307 228.904 96.7048 221.23 96.7048 211.763C96.7048 202.297 89.0307 194.623 79.5642 194.623C70.0977 194.623 62.4236 202.297 62.4236 211.763C62.4236 221.23 70.0977 228.904 79.5642 228.904ZM73.1366 201.05C71.9533 201.05 70.994 202.01 70.994 203.193C70.994 204.376 71.9533 205.335 73.1366 205.335H75.2791C76.8652 205.335 78.2501 206.197 78.991 207.478H73.1366C71.9533 207.478 70.994 208.437 70.994 209.621C70.994 210.804 71.9533 211.763 73.1366 211.763H78.991C78.2501 213.044 76.8652 213.906 75.2791 213.906H73.1366C72.27 213.906 71.4887 214.428 71.1571 215.228C70.8255 216.029 71.0088 216.951 71.6215 217.563L78.0493 223.991C78.886 224.828 80.2426 224.828 81.0793 223.991C81.916 223.154 81.916 221.798 81.0793 220.961L77.9008 217.782C80.6832 216.889 82.8459 214.613 83.5794 211.763H85.992C87.1753 211.763 88.1346 210.804 88.1346 209.621C88.1346 208.437 87.1753 207.478 85.992 207.478H83.5794C83.3838 206.718 83.0865 205.999 82.7029 205.335H85.992C87.1753 205.335 88.1346 204.376 88.1346 203.193C88.1346 202.01 87.1753 201.05 85.992 201.05H73.1366Z",
    fill: "url(#paint7_linear_11381_14456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11381_14456",
    x: 208.57,
    y: 59.3021,
    width: 92.1465,
    height: 79.8015,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.02136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.02136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368314 0 0 0 0 0.313726 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11381_14456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11381_14456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_11381_14456",
    x: 151.734,
    y: 155.831,
    width: 87.8359,
    height: 76.4401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.02136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.02136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368314 0 0 0 0 0.313726 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11381_14456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11381_14456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_11381_14456",
    x: 44.2277,
    y: 53.7363,
    width: 123.523,
    height: 100.923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.02136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368314 0 0 0 0 0.313726 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11381_14456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11381_14456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_11381_14456",
    x: 23.632,
    y: 172.971,
    width: 111.444,
    height: 94.8491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.02136
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.02136
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368314 0 0 0 0 0.313726 0 0 0 0 0.996078 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11381_14456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11381_14456",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11381_14456",
    x1: 157.455,
    y1: 210.327,
    x2: 155.063,
    y2: 369.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11381_14456",
    x1: 302.252,
    y1: 241.829,
    x2: 302.252,
    y2: 466.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D57DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D3ECC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11381_14456",
    x1: 315.843,
    y1: 320.622,
    x2: 422.931,
    y2: 371.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677966,
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11381_14456",
    x1: 311.338,
    y1: 217.242,
    x2: 309.458,
    y2: 277.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11381_14456",
    x1: 311.338,
    y1: 217.242,
    x2: 313.97,
    y2: 285.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11381_14456",
    x1: 308.218,
    y1: 185.29,
    x2: 308.218,
    y2: 257.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_11381_14456",
    x1: 100.162,
    y1: -71.2436,
    x2: 47.6703,
    y2: 116.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0171777,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_11381_14456",
    x1: 79.5642,
    y1: 194.623,
    x2: 79.5642,
    y2: 228.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD5B6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseUs);
export default __webpack_public_path__ + "static/media/choose-us.5d08780d4f9fbbcb7673e41f41d8518e.svg";
export { ForwardRef as ReactComponent };